// @flow
import React from "react";
import SwaggerUIReact from "swagger-ui-react";
import { View } from "@components";

import "swagger-ui-react/swagger-ui.css";

type Props = $Exact<{
  spec: Object,
  requestInterceptor?: (request: Object) => Object | Promise<Object>,
  docExpansion?: "list" | "full" | "none",
}>;

export default function SwaggerUI(props: Props) {
  return (
    <View className="gs-swagger-ui">
      <SwaggerUIReact
        spec={props.spec}
        requestInterceptor={props.requestInterceptor}
        docExpansion={props.docExpansion || "full"}
      />
    </View>
  );
}
